import { Dialog, DialogTitle, Divider } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import React, { useCallback, useRef } from 'react';
import { FormattedMessage } from 'intl';
import { CommonTranslationKeys } from 'intl/keys';

import { IssueWizard } from './index';
import { IssueWizardProps } from './types';

const dialogRootSx: SxProps<Theme> = {
  '& .MuiDialog-paper': {
    margin: 16,
    width: '100%',
  },
};

const dialogTitleSx: SxProps<Theme> = {
  p: '16px',
  '& .MuiTypography-root': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: '18px',
  },
};

export function CreateIssueDialog(
  props: IssueWizardProps & { open: boolean }
): React.ReactElement {
  const { open, ...wizardProps } = props;

  const wizardRef = useRef<{
    onCancel: () => Promise<void>;
  }>(null);

  const handleCloseDialog = useCallback(async () => {
    if (wizardRef.current) {
      await wizardRef.current.onCancel();
    }
  }, []);

  return (
    <Dialog
      sx={dialogRootSx}
      open={open}
      keepMounted={false}
      onClose={handleCloseDialog}
    >
      <DialogTitle sx={dialogTitleSx}>
        <FormattedMessage id={CommonTranslationKeys.toolbarTitleCreateIssue} />
      </DialogTitle>
      <Divider />
      <IssueWizard {...wizardProps} ref={wizardRef} />
    </Dialog>
  );
}
